import React from "react";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { withTranslation } from "react-i18next";

const DownloadExcel = ({ data, t }) => {
    const downloadAsExcel = async () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}/${(currentDate.getMonth() + 1).toString().padStart(2, "0")}/${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours().toString().padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate.getSeconds().toString().padStart(2, "0")}`;
        const downloadDateTime = `${t("Route Path Summary Report Generated on")}: ${formattedDate}, ${formattedTime}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(t("Route Path Summary"));

        const boldFont = { bold: true };

        worksheet.addRow(["", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 10); // Adjusted for 10 columns
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        worksheet.addRow(["", t("Route Path Summary Details"), ""]);
        worksheet.mergeCells(2, 2, 2, 10); // Adjusted for 10 columns
        worksheet.getCell(2, 2).value = t("Route Path Summary Details");
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        const tableHeaderRow = worksheet.addRow([
            t("S.No"),
            t("Route Code"),
            t("Starting Point Code"),
            t("Starting Point Name"),
            t("Ending Point Code"),
            t("Ending Point Name"),
            t("Created By (Route Incharge)"),
            t("Vehicle Number"),
            t("Driver Name"),
            t("Collection Points"),
            t("Zone"),
            t("Ward"),
            t("Status"),
        ]);

        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.alignment = { horizontal: "left" };
            if (colNumber >= 1 && colNumber <= 14) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "003366" },
                };
            }
        });

        data.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.routeCode || "N/A",
                item.startingCollectionPointCode || "N/A",
                item.startingPointName || "N/A",
                item.endingCollectionPointCode || "N/A",
                item.endingPointName || "N/A",
                item.routeSupervisorName || "N/A",
                item.vehicleNumber || "N/A",
                item.driverName || "N/A",
                item.collectionPointNames && item.collectionPointNames.length > 0 ? item.collectionPointNames.join(", ") : "N/A",
                item.zoneName || "N/A",
                item.circleName || "N/A",
                item.status ? "Active" : "Inactive",
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber >= 1 && colNumber <= 14) { // Adjusted for 11 columns
                    cell.alignment = { horizontal: "center" };
                }
            });
        });

        worksheet.columns = [
            { width: 5 }, // S.No
            { width: 15 }, // Route Code
            { width: 20 }, // Starting Point Code
            { width: 25 }, // Starting Point Name
            { width: 20 }, // Ending Point Code
            { width: 25 }, // Ending Point Name
            { width: 25 }, // Created By (Route Incharge)
            { width: 25 },
            { width: 25 },
            { width: 75 }, // Collection Points
            { width: 15 }, // Zone
            { width: 15 }, // Ward
            { width: 15 }, // Status
        ];

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "RouteSummaryPath.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };
 const downloadAsPDF = () => {
    const doc = new jsPDF({
        orientation: "landscape", // better for wide tables
        unit: "mm",
        format: "a4",
    });

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}/${(currentDate.getMonth() + 1).toString().padStart(2, "0")}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours().toString().padStart(2, "0")}:${currentDate.getMinutes().toString().padStart(2, "0")}:${currentDate.getSeconds().toString().padStart(2, "0")}`;
    const downloadDateTime = `${t("Route Path Summary Report Generated on")}: ${formattedDate}, ${formattedTime}`;

    // Header text
    doc.setFontSize(10);
    doc.text(downloadDateTime, doc.internal.pageSize.getWidth() / 2, 10, { align: "center" });

    doc.setFontSize(14);
    doc.text(t("Route Path Summary Details"), doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });

    // Table Headers
    const tableColumn = [
        t("S.No"),
        t("Route Code"),
        t("Start Code"),
        t("Start Name"),
        t("End Code"),
        t("End Name"),
        t("Incharge"),
        t("Vehicle No"),
        t("Driver Name"),
        t("Collection Points"),
        t("Zone"),
        t("Ward"),
        t("Status"),
    ];

    const tableRows = data.map((item, index) => [
        index + 1,
        item.routeCode || "N/A",
        item.startingCollectionPointCode || "N/A",
        item.startingPointName || "N/A",
        item.endingCollectionPointCode || "N/A",
        item.endingPointName || "N/A",
        item.routeSupervisorName || "N/A",
        item.vehicleNumber || "N/A",
        item.driverName || "N/A",
        item.collectionPointNames && item.collectionPointNames.length > 0 ? item.collectionPointNames.join(", ") : "N/A",
        item.zoneName || "N/A",
        item.circleName || "N/A",
        item.status ? "Active" : "Inactive",
    ]);

    autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 25,
        theme: "striped",
        styles: {
            fontSize: 7,
            cellPadding: 2,
            halign: "center",
            valign: "middle",
            overflow: 'linebreak'
        },
        headStyles: {
            fillColor: [0, 51, 102],
            textColor: 255,
            fontSize: 8,
        },
        columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 20 },
            2: { cellWidth: 20 },
            3: { cellWidth: 25 },
            4: { cellWidth: 20 },
            5: { cellWidth: 25 },
            6: { cellWidth: 25 },
            7: { cellWidth: 20 },
            8: { cellWidth: 25 },
            9: { cellWidth: 35 }, // Collection Points
            10: { cellWidth: 20 },
            11: { cellWidth: 20 },
            12: { cellWidth: 15 },
        },
        margin: { top: 30, bottom: 10 },
    });

    doc.save("RouteSummaryPath.pdf");
};


    return (
        <>
            <button className="btn btn-excel me-2" onClick={downloadAsExcel}>
                <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                {t("Excel")}
            </button>
            <button className="btn btn-excel" onClick={downloadAsPDF}>
                <i className="fa-solid fa-file-pdf me-1 icon-container"></i>
                {t("PDF")}
            </button>
        </>
    );
};

export default withTranslation()(DownloadExcel);